module.exports = __webpack_public_path__ + "static/media/nav-knowledge-and-skills-active.c730acd5.svg";